import { Chapter } from '../question/question.model';
import { Subject } from '../subject/subject.model';

export enum QuestionGeneratedType {
  Objective = 'objective',
  Subjective = 'subjective',
}

export interface QuestionGenerated {
  id: number;
  parentId: number;
  html: string;
  type: QuestionGeneratedType;
  subject: Subject;
  chapter: Chapter;
}

export interface GenerateQuestion {
  parentId: number;
  subjectUuid: string;
  form: number;
  chapterId: number;
  type: QuestionGeneratedType;
  html: string;
  openAiResponse: any;
  openAiConfig: any;
}
